<div class="confirmation">
    <h2 mat-dialog-title><mat-icon color="warn">warning</mat-icon> Warning</h2>
    <p>This action will deactivate the company and access for all of the users associated with this company.<br>Are you sure you want to proceed?</p>
    <div class="btn-group" role="group">
        <button mat-button [mat-dialog-close]="true">Yes</button>
        <button mat-button mat-dialog-close>No</button>
    </div>
</div>
